import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteGippel() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-gippel-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-gippel-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="gippel" />
      </div>
    </div>
  );
}

export default BodenfeuchteGippel;
